import { useEffect, useState } from "react";
import { Printer, FileImage } from "lucide-react";
import { toast } from "sonner";
import api, { downloadFile } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CONDITIONS, SITES } from "@/components/RequeteFields";

function ScanImage({ scanId }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    let u;
    api.get(`/requetes/scan/${scanId}/image`, { responseType: "blob" }).then((r) => { u = URL.createObjectURL(r.data); setUrl(u); }).catch(() => setErr(true));
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [scanId]);
  if (err) return <div className="text-xs text-red-600" data-testid="requete-scan-error">Image indisponible.</div>;
  if (!url) return <div className="text-xs text-slate-400">Chargement de l'image…</div>;
  return <a href={url} target="_blank" rel="noreferrer"><img src={url} alt="Requête numérisée" className="max-h-80 rounded border border-slate-200" data-testid="requete-scan-image" /></a>;
}

export const RequeteCard = ({ d }) => {
  const r = d.requete || {};
  const cond = CONDITIONS.filter(([k]) => (r.conditions || []).includes(k)).map(([, l]) => l);
  const sites = SITES.filter((s) => r.sites?.[s]);
  const rows = [["Date / heure de prélèvement", [r.date_prelevement, r.heure_prelevement].filter(Boolean).join(" ")], ["Heure de fixation", r.heure_fixation],
    ["Service", r.service], ["No de pratique", r.no_pratique], ["Préleveur", r.preleveur], ["C.C.", [r.cc1, r.cc2].filter(Boolean).join(" · ")],
    ["Diagnostic pré-opératoire", r.diagnostic_preop], ["Opération", r.operation]].filter(([, v]) => v);
  const print = () => downloadFile(`/demandes/${d.id}/requete/pdf`, `requete_${d.numero}.pdf`).catch(() => toast.error("Impression impossible"));
  return (
    <Card className="p-5 border-slate-200 text-sm space-y-3 mt-4" data-testid="requete-card">
      <div className="flex items-center justify-between gap-2">
        <div className="font-semibold text-slate-900">Requête d'anatomo-pathologie</div>
        <Button size="sm" variant="outline" onClick={print} data-testid="requete-print-button"><Printer className="h-4 w-4 mr-1" /> Imprimer la requête (PDF)</Button>
      </div>
      {cond.length > 0 && <div className="flex flex-wrap gap-1">{cond.map((c) => <span key={c} className="rounded bg-sky-50 px-2 py-0.5 text-xs font-semibold text-sky-700">☒ {c}</span>)}</div>}
      {rows.map(([k, v]) => <div key={k}><span className="text-slate-500">{k} :</span> {v}</div>)}
      {sites.length > 0 && (
        <div data-testid="requete-sites"><div className="text-slate-500 mb-1">Sites du prélèvement :</div>
          {sites.map((s) => <div key={s}><b className="inline-block w-5">{s}</b> {r.sites[s]}</div>)}</div>
      )}
      {!rows.length && !sites.length && !cond.length && <div className="text-slate-400 text-xs">Aucun détail de requête saisi.</div>}
      {r.scan_id && <div><div className="flex items-center gap-1 text-slate-500 mb-1"><FileImage className="h-4 w-4" /> Requête papier numérisée</div><ScanImage scanId={r.scan_id} /></div>}
    </Card>
  );
};
